import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * DAIMI Sertifikasyon Kursu — Türkçesi.
 *
 * Bölüm sırası, görseller, maddeler ve fiyat İngilizcesiyle birebir aynı;
 * değişen yalnızca nasıl söylendiği. Ürün adları ve yerleşik terimler İngilizce
 * kalıyor — DAIMI, Impact Platform, Digitopia Connect Platform, benchmark,
 * roadmap, Snowflake Analysis, Vitality Score, cohort.
 *
 * Müfredat başlıklarına dair açık soru İngilizce dosyada duruyor ve orada bir
 * kez duruyor — aynı karar iki dilde iki not olarak sayılmasın.
 */
export const daimiCourse: WrittenPage = {
  navLabel: 'DAIMI Sertifikasyon Kursu',
  title: 'Dijital ve Yapay Zeka Olgunluk Endeksi Sertifikasyon Kursu',
  description:
    'Sertifikalı DAIMI Practitioner olun. Bu kapsamlı online eğitimle dijital ve yapay zeka dönüşümünde uygulamalı bilgi edinin, güvenilir bir danışman olarak konumlanın.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Dijital ve Yapay Zeka Olgunluk Endeksi (DAIMI)',
      headline: 'Dijital ve Yapay Zeka Olgunluk Endeksi Sertifikasyon Kursu',
      sub: 'Sertifikalı DAIMI Practitioner olun',
      body: [
        'Bu kapsamlı online eğitimle dijital ve yapay zeka dönüşümünde uygulamalı bilgi edinin, güvenilir bir danışman olarak konumlanın.',
      ],
      ctas: [{ label: 'Hemen kaydolun', href: '#contact' }],
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'Danışmanlığın yeni dönemine öncülük edin',
      body: [
        'Dijital ve yapay zekanın artık ayrı girişimler olmadığı bir dönemde şirketlerin tek bir yol haritasına ihtiyacı var. Dijital ve Yapay Zeka Olgunluk Endeksi (DAIMI), bu ikiz dönüşümü ölçmek, benchmark’lamak ve hızlandırmak için tasarlanmış, sektörün önde gelen çerçevesi.',
        'Sertifikalı DAIMI Danışmanı olduğunuzda, kurumları karmaşık dijital dönüşümlerde veriye dayalı bir kesinlikle yönetecek çerçeveye, araçlara ve itibara sahip olursunuz.',
      ],
      photo: {
        src: '/photo/learning-platform-tablet.webp',
        alt: 'Bir tablette Digitopia Learning Platform giriş ekranı.',
      },
      ctas: [{ label: 'Hemen kaydolun', href: '#contact' }],
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Neden DAIMI sertifikası?',
      points: [
        'Kanıtlanmış çerçeve: Digitopia’nın geliştirdiği kapsamlı çerçeveyle titiz, kanıta dayalı değerlendirmeler yapın.',
        'Rekabet avantajı: C-level yöneticileri ortak bir dilde buluşturabilen bir dönüşüm lideri olarak öne çıkın.',
        'Size özel araçlar: Impact Platform’a ve benchmark verisine erişerek performansı sektör emsalleriyle karşılaştırın.',
        'Ekosistemin parçası olun: Sertifikanızın ardından Digitopia Connect Platform ağına katılın; aynı alanda çalışan profesyonellerle ve dijital olgunluk uzmanlığınızı arayan şirketlerle buluşun.',
      ],
      photo: {
        src: '/photo/consultant-impact-platform-recommendations.webp',
        alt: 'Bir danışman, masaüstü ekranında Impact Platform’un öneriler listesini ve bubble chart’ını inceliyor.',
      },
      ctas: [{ label: 'Kaydolun', href: '#contact' }],
    },
    {
      kind: 'features',
      heading: 'Kurs müfredatı',
      sub: 'Sertifikasyon programı sizi temel teoriden ileri düzey uygulamaya taşıyacak şekilde kurgulandı.',
      columns: 2,
      textSize: 'lg',
      items: [
        {
          title: 'Dijital dönüşüme ve yapay zekaya giriş',
          body: '“İkiz dönüşüm” gerçeğini anlayın. Yapay zekanın ölçeklenmesi için dijital temellerin neden şart olduğunu ve yapay zekanın dijital disrupsiyonu nasıl hızlandırdığını öğrenin.',
        },
        {
          title: 'DAIMI çerçevesi',
          body: 'Altı boyutu (Customer, Operations, Innovation, People, Governance, Technology) ve beş olgunluk seviyesini (Initial’dan Optimizing’e) derinlemesine inceleyin.',
        },
        {
          title: 'Yeni danışmanlık çerçevesi',
          body: 'Practitioner yolculuğunda ustalaşın: Assess — etkili paydaş görüşmeleri yapın ve kanıt toplayın. Benchmark — olgunluk seviyelerini global sektör standartlarına göre kalibre edin. Prioritize — yüksek etkili iyileştirme alanlarını ve “quick win”leri belirleyin.',
        },
        {
          title: 'Impact Platform',
          body: 'Bulguları “Snowflake Analysis” ile görselleştirmeyi, “Vitality Score”ları takip etmeyi ve uygulanabilir dönüşüm roadmap’leri kurmayı öğrenin.',
        },
      ],
      footnote:
        'DAIMI Sertifikasyon Kursu çok yakında başlıyor. Şu anda ilk cohort’ta yer almak isteyen danışmanlardan, dijital liderlerden ve dönüşüm uzmanlarından başvuru alıyoruz.',
      cta: { label: 'Hemen kaydolun', href: '#contact' },
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'DAIMI nedir?',
      body: [
        'Dijital ve Yapay Zeka Olgunluk Endeksi (DAIMI), kurumların dijital ve yapay zeka yetkinliklerinin şirket genelinde ne kadar iyi tanımlandığını, yönetildiğini ve hayata geçirildiğini anlamasına yardımcı olur. Olgunluk boşluklarını ve yapısal kısıtları ortaya çıkarır, performansı emsallerle benchmark’lar ve iyileştirme önceliklerini netleştirir. DAIMI; ortak bir başlangıç noktası, net bir roadmap ve sürekli görünür ilerleme ile stratejiyi uygulamaya dönüştürür.',
      ],
      // Bu kart gri bandın (`bg-band`) üstünde duruyor, o yüzden çarkın Türkçe
      // basılmış hâli gösteriliyor: beyaz harflerle çıkarılmış İngilizce
      // export (`daimi-framework-wheel-white.webp`) koyu bantlar için, açık
      // zeminde altı boyutun isimleri kaybolur.
      photo: {
        src: '/photo/daimi-framework-wheel-turkce-labelled.png',
        alt: 'DAIMI çarkı: Dijital ve Yapay Zeka Olgunluk Endeksi’nin çevresinde İnsan, Müşteri, Operasyon, İnovasyon, Yönetişim ve Teknoloji; her birinin altında ölçülen alt boyutlarla.',
      },
      ctas: [
        { label: 'Daha fazla bilgi', href: LINKS.daimi },
        { label: 'Uzmanla görüşün', href: '#contact' },
      ],
    },
    {
      kind: 'prose',
      align: 'center',
      size: 'lg',
      heading: 'Yapay zekayı güvenle ölçekleyin: DAIMI Kursu’na kaydolun',
      sub: 'DAIMI Practitioner Kursu’nun standart ücreti 450 USD’dir. Size özel fiyat ve kampanyalarımız da var.',
      paragraphs: [
        'İndirim hakkınızı öğrenmek veya yaklaşan cohort’ta yerinizi ayırtmak için aşağıdaki formu doldurun. Ekibimiz kayıt detaylarınızla size dönecek.',
      ],
    },
  ],
}
